import { useQuery } from '@tanstack/react-query';
import { userApi } from '../api/user.api';
import { userKeys } from '../api/user.keys';

export function useUserDetails(id: any) {
  return useQuery({
    queryKey: userKeys.detail(id),
    queryFn: () => userApi.getById(id),
    enabled: !!id,
  });
}
